import React from 'react';
import type { OrderBumpCard } from '../../../offer.types';
import { formatCurrency } from '../../../utils/formatting';

interface AcceptedBumpsListProps {
  bumps: OrderBumpCard[];
  acceptedNanoIds: string[];
  onRemove?: (nanoId: string) => void;
}

export const AcceptedBumpsList: React.FC<AcceptedBumpsListProps> = ({ bumps, acceptedNanoIds, onRemove }) => {
  const acceptedSet = new Set(acceptedNanoIds);
  const items = bumps.filter((b) => acceptedSet.has(b.nanoId));

  if (items.length === 0) return null;

  return (
    <div className="pr-2 space-y-1 border-t border-gray-200 dark:border-gray-700 pt-2">
      {items.map((bump) => (
        <div
          key={bump.nanoId}
          className="flex items-start py-3 border border-dashed border-yellow-400 rounded-md bg-yellow-50/60 dark:bg-yellow-900/20 p-2"
        >
          {bump.imageUrl && (
            <img
              src={bump.imageUrl}
              alt={bump.title}
              className="w-16 h-16 object-cover rounded-md mr-3"
            />
          )}
          <div className="flex-1 min-w-0">
            <span className="inline-block bg-yellow-400 text-yellow-900 font-bold text-[10px] tracking-wide px-2 py-0.5 rounded mb-1">
              OFERTA ADQUIRIDA
            </span>
            <h4 className="text-xs font-medium text-text-primary dark:text-gray-100 opacity-80 leading-tight">
              {bump.title}
            </h4>
            <p className="text-xs text-text-secondary dark:text-gray-400 mt-1">Qtd: 1</p>
          </div>
          <div className="flex flex-col items-end gap-2 pl-2">
            <p className="text-sm font-semibold text-text-primary dark:text-gray-100">
              {formatCurrency(bump.price)}
            </p>
            {onRemove && (
              <button
                type="button"
                onClick={() => onRemove(bump.nanoId)}
                className="text-gray-500 hover:text-red-600 transition-colors"
                aria-label="Remover oferta"
                title="Remover oferta"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="3 6 5 6 21 6" />
                  <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                  <path d="M10 11v6" />
                  <path d="M14 11v6" />
                  <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
                </svg>
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
